// extracted by mini-css-extract-plugin
export var container = "_n4-0";
export var dotAnimation = "_n4-2";
export var dotsLoading = "_n4-1";